import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Trip, TripFilters, TripSort } from '../../lib/types/models/trip/trip'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTrips(input: PaginationRequest<TripFilters, string, Version, TripSort> = {}) {
  if (!input.sort) input.sort = { departure: { label: 'asc' } }
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripFilters>>(
        constructApiUrl(API.trips.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<Trip>>()
}
